import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

import ProgressClock from "common/assets/progress-clock";
import {
  ACTIVE,
  APPROVED,
  WITH_ERROR,
  IN_REVIEW,
  REJECTED,
} from "common/constants/budget-status.constants";
import theme from "common/themes/default.theme";

export const BUDGET_FILLING_STORE = "budget_filling_store";
export const BUDGET_DETAILING_STORE = "budget_detailing_store";

export const assignIcon = (templateStatusId) => {
  let icon = AccessAlarmIcon;
  let color = "#ffffff";
  let label = "";
  switch (templateStatusId) {
    case ACTIVE:
      icon = AccessAlarmIcon;
      color = theme.palette.grey["600"];
      label = "Active";
      break;
    case IN_REVIEW:
      icon = ProgressClock;
      color = theme.palette.blue.main;
      label = "In Review";
      break;
    case REJECTED:
      icon = HighlightOffIcon;
      color = theme.palette.error.main;
      label = "Rejected";
      break;
    case APPROVED:
      icon = CheckCircleOutlineIcon;
      color = theme.palette.success.main;
      label = "Approved";
      break;
    case WITH_ERROR:
      icon = ErrorOutlineIcon;
      color = theme.palette.warning.main;
      label = "With error";
      break;
    default:
      icon = AccessAlarmIcon;
      color = "#ffffff";
      label = "Not Defined";
  }
  return { id: templateStatusId, icon, color, label };
};
